var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAdjustmentsAlt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 11C4.6 11 5 10.6 5 10V3C5 2.4 4.6 2 4 2C3.4 2 3 2.4 3 3V10C3 10.6 3.4 11 4 11ZM12 11C11.4 11 11 11.4 11 12V21C11 21.6 11.4 22 12 22C12.6 22 13 21.6 13 21V12C13 11.4 12.6 11 12 11ZM20 13C20.6 13 21 12.6 21 12V3C21 2.4 20.6 2 20 2C19.4 2 19 2.4 19 3V12C19 12.6 19.4 13 20 13ZM7 13H1C0.4 13 0 13.4 0 14C0 14.6 0.4 15 1 15H3V21C3 21.6 3.4 22 4 22C4.6 22 5 21.6 5 21V15H7C7.6 15 8 14.6 8 14C8 13.4 7.6 13 7 13ZM15 7H13V3C13 2.4 12.6 2 12 2C11.4 2 11 2.4 11 3V7H9C8.4 7 8 7.4 8 8C8 8.6 8.4 9 9 9H15C15.6 9 16 8.6 16 8C16 7.4 15.6 7 15 7ZM23 15H17C16.4 15 16 15.4 16 16C16 16.6 16.4 17 17 17H19V21C19 21.6 19.4 22 20 22C20.6 22 21 21.6 21 21V17H23C23.6 17 24 16.6 24 16C24 15.4 23.6 15 23 15Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAdjustmentsAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconAdjustmentsAlt.bdcd7d3e0234c1d59d8e14e67c436a52.svg";